import Tooltip from '@cartwhl/ui/atoms/Tooltip';
import ResetIcon from '@cartwhl/ui/icons/ResetIcon';

const RESET_BUTTON_CLASS =
  'border-gray-30/80 dark:border-gray-60/80 bg-white/45 dark:bg-gray-90/45 text-primary hover:bg-white/65 dark:hover:bg-gray-90/70 inline-flex h-5 w-5 items-center justify-center rounded-md border transition-colors';
const RESET_BUTTON_SLOT_CLASS = 'inline-flex h-5 w-5';

interface ResetToDefaultButtonProps {
  label: string;
  isDefault: boolean;
  onReset: () => void;
  tooltipText?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  inModal?: boolean;
  buttonClassName?: string;
  slotClassName?: string;
  iconClassName?: string;
}

export default function ResetToDefaultButton({
  label,
  isDefault,
  onReset,
  tooltipText,
  side = 'top',
  inModal = true,
  buttonClassName,
  slotClassName,
  iconClassName = 'h-3 w-3',
}: ResetToDefaultButtonProps) {
  const resetLabel = tooltipText ?? `Reset ${label} to default`;
  return (
    <Tooltip text={resetLabel} side={side} inModal={inModal} disabled={isDefault}>
      <span className={slotClassName ?? RESET_BUTTON_SLOT_CLASS}>
        <button
          type="button"
          className={`${buttonClassName ?? RESET_BUTTON_CLASS} ${
            isDefault ? 'pointer-events-none opacity-0' : 'opacity-100'
          }`}
          onClick={onReset}
          aria-label={resetLabel}
          tabIndex={isDefault ? -1 : 0}
        >
          <ResetIcon className={iconClassName} />
        </button>
      </span>
    </Tooltip>
  );
}
